import { render, staticRenderFns } from "./PPCImageInfo.vue?vue&type=template&id=3d72129c&"
import script from "./PPCImageInfo.vue?vue&type=script&lang=js&"
export * from "./PPCImageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports